import React, { FC } from 'react';

import { Avatar, Grid } from '@material-ui/core';
import { navigate } from '@reach/router';

import { InvitationBannerStyled } from './InvitationBanner.Styles';
import { defaultClubLogo } from '../../../../../../../assets/images';

interface IProps {
  id: string | number;
  name: string;
  image: string | null | undefined;
}

const InvitationBanner: FC<IProps> = props => {
  const { id, name, image } = props;

  const onClick = () => navigate(`/club-payment/${id}`);

  return (
    <InvitationBannerStyled onClick={onClick}>
      <Grid className="grid-container" container={true} spacing={0}>
        <Grid className="avatar-container" item={true} xs={3}>
          <Avatar alt="Remy Sharp" src={image || defaultClubLogo} className="avatar" />
        </Grid>

        <Grid className="info" item={true} xs={7}>
          <div className="title">Join the club</div>

          <div className="itemName">{name}</div>
        </Grid>

        <Grid className="cta" item={true} xs={2}>
          VIEW INVITE
        </Grid>
      </Grid>
    </InvitationBannerStyled>
  );
};

export default InvitationBanner;
